import { connect } from 'react-redux';
import DescriptionWidget from 'nucleus-widgets/lib/Description/DescriptionWidget';
import { isStyledDescription } from '../../utils/rteMvcUtils';

/**
 * Data wrapper for the event description widget.
 */
export default connect((state) => {
  const translate = state.text.translate;
  return {
    text: translate(state.event.description),
    shouldRenderHtml: isStyledDescription(translate(state.event.description))
  };
})(DescriptionWidget);
